import { render, staticRenderFns } from "./TabelaMensalista.vue?vue&type=template&id=e2fef290&scoped=true&"
import script from "./TabelaMensalista.vue?vue&type=script&lang=js&"
export * from "./TabelaMensalista.vue?vue&type=script&lang=js&"
import style0 from "./TabelaMensalista.vue?vue&type=style&index=0&id=e2fef290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fef290",
  null
  
)

export default component.exports